import { getUserInfo } from "@/js/request/uisRequest"
import localstorageUtil,{ localStorageKey } from "./localstorageUtil"
import Supporter from "./supporter"

const enoughArticle = 11 // 多少篇文章浏览触发提醒
const isHuawei = Supporter.isHuawei
/**
 * @description 截取对象的前len个值
 * @param {Object} obj 要截取的对象
 * @param {Number} len 要截取的长度
 * @param {String} sortType 排序类型，desc降序，asc升序
 * @returns {Object} 截取后的对象
 */
const sliceObjByValue = ({obj = {}, len, sortType = 'desc'}) => {
    const keys = Object.keys(obj)
    const sortedKeys = keys.sort((a, b) => {
        return sortType === 'desc' ? obj[b] - obj[a] : obj[a] - obj[b]
    })
    const slicedKeys = sortedKeys.slice(0, len)
    
    const slicedObj = {}
    for (const key of slicedKeys) {
        slicedObj[key] = obj[key]
    }
    return slicedObj
}
/**
 * @description 以每七天为一个周期，记录用户浏览历史，便于判断是否展示提示条
 * 最多记录enoughArticle条文章
 */
const cacheSevenDaysHistory = (articleId) => {
    let history = localstorageUtil.getItem(localStorageKey.sevenDaysBrowseHistory)
    const expireTime = 7 * 24 * 60 * 60 * 1000 // 过期时间为7天
    const nowTime = Date.now()
    const isExpired = nowTime > history?.cycleStart + expireTime
    // 如果无历史记录,或者过期，则将当前浏览记录设置为初始数据
    if(!history || isExpired){
        history = {
            cycleStart: nowTime,
            isShow: false,
            viewedArticles: {
                [articleId]: nowTime
            },
        }
        localstorageUtil.setItem(localStorageKey.sevenDaysBrowseHistory, history, expireTime)
    } else {
        history.viewedArticles[articleId] = nowTime
        history.viewedArticles = sliceObjByValue({
            obj: history.viewedArticles,
            len: enoughArticle
        })
        localstorageUtil.setItem(localStorageKey.sevenDaysBrowseHistory, history, expireTime)
    }
}

/**
 * @description 未登录用户，缓存浏览历史
 * 最多记录300条
 * @param {string} articleId 文章id
 */
const cacheUnloginBrowseHistory = (articleId) => {
    let history = localstorageUtil.getItem(localStorageKey.browseHistory) || {}
    const expireTime = 180 * 24 * 60 * 60 * 1000 // 过期时间为180天
    history[articleId] = Date.now()
    history = sliceObjByValue({
        obj: history,
        len: 300
    })
    localstorageUtil.setItem(localStorageKey.browseHistory, history, expireTime)
}

/**
 * @description 删除未登录浏览历史
 */
const deleteUnloginBrowseHistory = () => {
    localstorageUtil.removeItem(localStorageKey.browseHistory)
    localstorageUtil.removeItem(localStorageKey.sevenDaysBrowseHistory)
}

/**
 * @description 已登录用户,缓存浏览历史，仅用于判断登录时是否展示提示条
 * 最多记录enoughArticle条文章
 * @param {string} articleId 文章id
 */
const cacheLoginBrowseHistory = (articleId) => {
    const currentTime = Date.now()
    let history = localstorageUtil.getItem(localStorageKey.onlineBrowseHistory) || {}
    history[articleId] = currentTime
    history = sliceObjByValue({
        obj: history,
        len: enoughArticle
    })
    localstorageUtil.setItem(localStorageKey.onlineBrowseHistory, history)
}

/**
 * @description 删除登录浏览历史
 */
const deleteLoginBrowseHistory = () => {
    localstorageUtil.removeItem(localStorageKey.onlineBrowseHistory)
}

/**
 * @description 记录浏览历史
 * @param {*} articleId 文章id
 */
export const addBrowseHistory = async (articleId) => {
    try {
        const res = await getUserInfo()
        const isLogin = res?.code == 1 && res?.data
        if(isLogin){
            cacheLoginBrowseHistory(articleId)
        } else {
            cacheUnloginBrowseHistory(articleId)
            cacheSevenDaysHistory(articleId) // 统计七天一个周期内用户浏览历史
        }
    } catch (error) {
        console.log('获取登录信息失败', error)
        cacheUnloginBrowseHistory(articleId)
        cacheSevenDaysHistory(articleId)
    }
}

/**
 * @description 判断已登录用户是否需要展示浏览历史功能提示条
 * 条件：未曾触发过提示，且浏览过10篇以上的文章,且不为华为浏览器
 * @returns {Boolean} 是否需要展示提示条
 */
export const isLoginUserShowRemind = () => {
    if(isHuawei) return false // 华为手机不显示
    const onlineBrowseHistory = localstorageUtil.getItem(localStorageKey.onlineBrowseHistory)
    if(!onlineBrowseHistory) return false
    const browseHistoryLength = Object.keys(onlineBrowseHistory)?.length
    const isBrowseEnoughArticle = browseHistoryLength >= enoughArticle
    const browseRemindNum = localstorageUtil.getItem(localStorageKey.browseHistoryRemindNum) || 0
    return isBrowseEnoughArticle && browseRemindNum < 1
}
/**
 * @description 判断未登录用户是否需要展示提示条
 * 条件：七天一个周期，每个周期浏览超十篇文章触发提醒，每个周期一次提醒，最多触发5次，且不为华为浏览器
 * @returns {Boolean} 是否需要展示提示条
 */
export const isUnloginUserShowRemind = () => {
    if(isHuawei) return false // 华为手机不显示
    const history = localstorageUtil.getItem(localStorageKey.sevenDaysBrowseHistory)
    if(!history) return false
    const historyLength = Object.keys(history?.viewedArticles || {}).length
    const browseRemindNum = localstorageUtil.getItem(localStorageKey.browseHistoryRemindNum) || 0
    const isShow = history?.isShow
    const result = historyLength >= enoughArticle && browseRemindNum < 5 && !isShow
    result && localstorageUtil.setItem(localStorageKey.sevenDaysBrowseHistory, {
        ...history,
        isShow: true
    })
    return result
}